// You found it!
export default function showConfetti() {
  const DURATION = 5000
  const PARTICLE_COUNT = 100
  const COLORS = ["#14b8a6", "#f43f5e", "#3b82f6", "#eab308", "#a855f7", "#f97316", "#06b6d4"]
  const SHAPES = ["square", "circle"]

  const container = document.createElement("div")
  container.style.cssText =
    "position:fixed;inset:0;pointer-events:none;z-index:99999;overflow:hidden"
  document.body.appendChild(container)

  for (let i = 0; i < PARTICLE_COUNT; i++) {
    const particle = document.createElement("div")
    const color = COLORS[Math.floor(Math.random() * COLORS.length)]
    const shape = SHAPES[Math.floor(Math.random() * SHAPES.length)]
    const size = Math.random() * 8 + 4
    const x = Math.random() * 100
    const drift = (Math.random() - 0.5) * 200
    const delay = Math.random() * 2000
    const fallDuration = Math.random() * 2000 + 3000
    const spin = Math.random() * 720 - 360

    particle.style.cssText = [
      "position:absolute",
      `width:${size}px`,
      `height:${size}px`,
      `background:${color}`,
      shape === "circle" ? "border-radius:50%" : `border-radius:${Math.random() > 0.5 ? "2px" : "0"}`,
      `left:${x}%`,
      "top:-20px",
      "opacity:1",
      `animation:confetti-fall ${fallDuration}ms ${delay}ms ease-in forwards`,
      `--drift:${drift}px`,
      `--spin:${spin}deg`,
    ].join(";")

    container.appendChild(particle)
  }

  if (!document.getElementById("confetti-keyframes")) {
    const style = document.createElement("style")
    style.id = "confetti-keyframes"
    style.textContent = `
      @keyframes confetti-fall {
        0%   { transform: translateY(0) translateX(0) rotate(0deg); opacity: 1; }
        75%  { opacity: 1; }
        100% { transform: translateY(100vh) translateX(var(--drift)) rotate(var(--spin)); opacity: 0; }
      }
    `
    document.head.appendChild(style)
  }

  setTimeout(() => container.remove(), DURATION + 1000)
}
